module.exports = __webpack_public_path__ + "img/sand-2.10c80fab.png";